module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-bold-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-bold-webfont.svg
// module id = 47
// module chunks = d-game